<template>
</template>

<script>
export default {
  middleware: [
    'fetchUser',
    'isAuthorized',
    'allowNonMember',
    'hasBeenInducted',
    'initializer'
  ]
}
</script>

<style lang="scss" scoped>

</style>
